(function() {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignController', Controller);

    Controller.$inject = ['$scope', '$filter', '$state', '$modal', 'topBarService', 'surveyCampaignService', 'campaign', 'respondents', 'parts', 'pagerService'];

    function Controller($scope, $filter, $state, $modal, topBarService, surveyCampaignService, campaign, respondents, parts, pagerService) {
        var unregisterWatchRespondents = undefined;
        var hasQuestions = _.some(parts, function (part) { return part.QuestionsByID && _.size(part.QuestionsByID) > 0; });
        if (!hasQuestions) {
            $state.go('survey.campaign.slug.part');
        }

        $scope.$on('$destroy', destroy);

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn');

        $scope.campaign                  = campaign;
        $scope.respondents               = respondents;
        $scope.filteredRespondents       = [];
        $scope.view                      = {};
        $scope.view.isMultiSelect        = false;
        $scope.getStatusCount            = getStatusCount;
        $scope.addRespondent             = addRespondent;
        $scope.removeRespondent          = removeRespondent;
        $scope.unlockCompletion          = unlockCompletion;
        $scope.sendReminder              = sendReminder;
        $scope.lockCampaign              = lockCampaign;
        $scope.toggleMultiSelection      = toggleMultiSelection;
        $scope.selectAllRespondents      = selectAllRespondents;
        $scope.unselectAllRespondents    = unselectAllRespondents;
        $scope.sendReminderToAllSelected = sendReminderToAllSelected;
        $scope.isSomeRespondentsSelected = isSomeRespondentsSelected;
        $scope.updateStatus              = updateStatus;
        $scope.updateSearch              = updateSearch;
        $scope.pager                     = pagerService.newPager({ numberOfItemsPerPage: 11 });

        watchRespondents();

        function destroy() {
            if (unregisterWatchRespondents) unregisterWatchRespondents();
            $scope.filteredRespondents.length = 0;
            $scope.pager = undefined;
        }

        function watchRespondents() {
            if (unregisterWatchRespondents) unregisterWatchRespondents();

            unregisterWatchRespondents = $scope.$watch('respondents', function (newVal, oldVal) {
                updateFilteredRespondents();
            }, true);
        }

        function getStatusCount(status) {
            return _.filter($scope.respondents, { RespondentStatus: status }).length;
        }

        function addRespondent() {
            // Modal to select Owner
            var modalScope = $scope.$new(true);
            modalScope.actualRespondents = $scope.respondents;

            var selectNewRespondentModal = $modal({
                scope: modalScope,
                template: '/app/Main/survey/campaign/selectNewRespondentModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function() {
                selectNewRespondentModal.$promise.then(selectNewRespondentModal.hide);
            }

            modalScope.okModal = function() {
                modalScope.hideModal();
            }

            // Add the selected respondent
            modalScope.addRespondent = function(selectedEmployee) {
                surveyCampaignService
                    .addCampaignRespondent($scope.campaign.SlugObject, selectedEmployee)
                    .then(function(newRespondentEmployeeObject) {
                        $scope.respondents.push(newRespondentEmployeeObject);

                        modalScope.hideModal();
                    });
            }

            // Add the selected respondent
            modalScope.addRespondentWithSubordinates = function (selectedEmployee) {
                surveyCampaignService
                    .addRespondentWithSubordinates($scope.campaign.SlugObject, selectedEmployee)
                    .then(function (addedRespondents) {
                        _.forEach(addedRespondents, function (respondant) {
                            $scope.respondents.push(respondant);
                        });

                        modalScope.hideModal();
                    });
            }
        }

        // Remove Respondent
        function removeRespondent(respondent) {
            return surveyCampaignService
                .removeCampaignRespondent($scope.campaign.SlugObject, respondent.CampaignRespondentID)
                .then(function() {
                    $scope.respondents = _.reject($scope.respondents, { CampaignRespondentID: respondent.CampaignRespondentID });
                });
        }

        // Unlock Completion for Respondent
        function unlockCompletion(respondent) {
            return surveyCampaignService
                .unlockCompletionCampaignRespondent($scope.campaign.SlugObject, respondent.CampaignRespondentID)
                .then(function(updatedRespondent) {
                    respondent.CompletionSurveyDate = undefined;
                    _.assign(respondent, updatedRespondent);
                });
        }

        // Send Reminder
        function sendReminder(respondent) {
            return surveyCampaignService
                .sendEmailToRepondent($scope.campaign.SlugObject, $scope.campaign, respondent)
                .then(function(updatedRespondent) {
                    _.assign(respondent, updatedRespondent);
                });
        }

        // Lock Campaign
        function lockCampaign() {
            surveyCampaignService
                .lockCampaign(campaign.SlugObject)
                .then(function() {
                    $state.go('survey.campaign', {}, { reload: true });
                });
        }

        // Multi Selection
        function toggleMultiSelection() {
            $scope.view.isMultiSelect = !$scope.view.isMultiSelect;

            if ($scope.view.isMultiSelect) {
                $scope.unselectAllRespondents();
            }
        }

        // Select All Respondents
        function selectAllRespondents() {
            _.map($scope.filteredRespondents, function(respondent) {
                respondent.isSelected = true;
                return respondent;
            });
        }

        // Unselect All Respondents
        function unselectAllRespondents() {
            $scope.respondents = _.map($scope.respondents, function(respondent) {
                respondent.isSelected = false;
                return respondent;
            });
        }

        // Send Reminder to All Selected
        function sendReminderToAllSelected() {
            _.forEach($scope.respondents, function(respondent) {
                if (respondent.isSelected) {
                    respondent.isSelected = undefined;
                    $scope.sendReminder(respondent);
                }
            });

            $scope.toggleMultiSelection();
        }

        // is Some Respondents Selected
        function isSomeRespondentsSelected() {
            return _.some($scope.respondents, { isSelected: true });
        }

        function updateStatus(status) {
            $scope.status = status;

            updateFilteredRespondents();
        }

        function updateSearch(search) {
            $scope.search = search;

            updateFilteredRespondents();
        }

        function updateFilteredRespondents() {
            $scope.filteredRespondents.length = 0;

            var filteredRespondents = getFilteredRespondents();
            _.forEach(filteredRespondents, function(respondent) {
                $scope.filteredRespondents.push(respondent);
            });

            $scope.pager.updatePagerFromItems($scope.filteredRespondents);
        }

        // Helpers
        function getFilteredRespondents() {
            if (!$scope.status && !$scope.search) return $scope.respondents;

            var filteredByStatus = $scope.respondents;
            if ($scope.status) filteredByStatus = _.filter(filteredByStatus, { RespondentStatus: $scope.status });

            var columnsToSearch = ['DisplayName',
                                   'EmployeePositionEN',
                                   'EmployeeDepartmentEN',
                                   'EmployeeLogin'];

            return $filter('filterBy')(filteredByStatus, columnsToSearch, $scope.search);
        }
    }
})();